/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
const cache = {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
}
const system = {
    loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
            if (containsPii) {
                return;
            }
            switch (level) {
                case LogLevel.Error:
                    console.error(message);
                    return;
                case LogLevel.Info:
                    console.info(message);
                    return;
                case LogLevel.Verbose:
                    console.debug(message);
                    return;
                case LogLevel.Warning:
                    console.warn(message);
                    return;
            }
        }
    }
}
const aadConfigLocal = {
    auth: {
        clientId: "98f141c8-cc75-4564-81fd-0cab0e8172f3",
        authority: "https://login.microsoftonline.com/8b24551d-7c2c-4beb-8b61-95f32d9929ef",
        redirectUri: "/"
    },
    cache: cache,
    system: system
};

const aadConfigPipeline = {
    //AAD client ID for non-prod, need to enhance to pipeline based on branch environemnt to choose the configuration 
    // auth: {
    //    clientId: "98f141c8-cc75-4564-81fd-0cab0e8172f3",
    //    authority: "https://login.microsoftonline.com/8b24551d-7c2c-4beb-8b61-95f32d9929ef",
    //    redirectUri: "/"
    // },
    //AAD client ID for prod
    auth: {
        clientId: "REACT_APP_CLIENTID",
        authority: "REACT_APP_AUTHORITY",
        redirectUri: "/"
    },
    cache: cache,
    system: system
};
export const aadConfig = process.env.REACT_APP_STATE === 'pipeline' ? aadConfigPipeline : aadConfigLocal;

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */

//docs fix Signature:  https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/521#issuecomment-577400515
var scopeDefault = aadConfig.auth.clientId + "/.default";
const loginRequestLocal = {
    scopes: [scopeDefault]
};

const loginRequestPipeline = {
    scopes: [scopeDefault]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
const graphConfigLocal = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

const graphConfigPipeline = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

export const loginRequest = process.env.REACT_APP_STATE === 'pipeline' ? loginRequestPipeline : loginRequestLocal;
export const graphConfig = process.env.REACT_APP_STATE === 'pipeline' ? graphConfigPipeline : graphConfigLocal;